export default __webpack_public_path__ + "static/media/people14.36d62dbe.jpeg";